let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("IZf4J")).then(() => parcelRequire('kQUup'));